import React, { CSSProperties } from 'react'
import { Container, CloseIcon } from './styles'

type TypeModalProps = {
  isOpenModal: boolean
  pageTitle: string
  onClickButtonCancel: () => void
  Children: JSX.Element
  refModal?: React.LegacyRef<HTMLElement>
  styles?: CSSProperties
  sectionStyle?: CSSProperties
}

const Modal = ({
  pageTitle,
  isOpenModal,
  Children,
  refModal,
  onClickButtonCancel,
  styles,
  sectionStyle
}: TypeModalProps): JSX.Element => {
  const handleClickCloseModal = () => {
    onClickButtonCancel()
  }

  return (
    <Container openModal={isOpenModal} style={styles}>
      <section ref={refModal} style={sectionStyle}>
        <header>
          <h4 className="modal-title">{pageTitle}</h4>
          <div>
            <CloseIcon onClick={handleClickCloseModal} />
          </div>
        </header>
        <hr />
        <main>
          <div className="wrapper-body">{Children}</div>
        </main>
      </section>
    </Container>
  )
}

export default Modal
